import React, { FC, memo, useCallback } from 'react';
import { getActions } from '../../global';

import { ensureProtocol } from '../../util/ensureProtocol';
import renderText from '../common/helpers/renderText';
import useCurrentOrPrev from '../../hooks/useCurrentOrPrev';

import ConfirmDialog from '../ui/ConfirmDialog';
import { useTranslation } from 'react-i18next';

export type OwnProps = {
  url?: string;
};

const SafeLinkModal: FC<OwnProps> = ({ url }) => {
  const { toggleSafeLinkModal } = getActions();

  const { t } = useTranslation();

  const handleOpen = useCallback(() => {
    window.open(ensureProtocol(url), '_blank', 'noopener');
    toggleSafeLinkModal({ url: undefined });
  }, [toggleSafeLinkModal, url]);

  const handleDismiss = useCallback(() => {
    toggleSafeLinkModal({ url: undefined });
  }, [toggleSafeLinkModal]);

  const renderingUrl = useCurrentOrPrev(url);

  return (
    <ConfirmDialog
      isOpen={Boolean(url)}
      onClose={handleDismiss}
      title={t('OpenUrlTitle')}
      textParts={renderText(String(renderingUrl), ['links'])}
      confirmLabel={t('OpenUrlTitle')}
      confirmHandler={handleOpen}
    />
  );
};

export default memo(SafeLinkModal);
